import {
  CalendarRange,
  CheckSquare,
  Clock,
  Gavel,
  GitBranch,
  Mail,
  ShieldAlert,
} from 'lucide-react';

import { ENABLE_MAIL_INTEL } from '../config/features';

/**
 * The Analytics section's sections (Mail only with ENABLE_MAIL_INTEL), each with its own URL. Shared
 * between ProjectRegisterPage (which reads the current path to know what to
 * render) and Sidebar (which reads it to know which nav item to highlight),
 * so the id/path/icon/label for a section is defined once instead of
 * drifting between the two places that need it.
 */
export const ANALYTICS_TABS = [
  {
    id: 'insights',
    label: 'Insights',
    icon: CalendarRange,
    path: '/analytics/insights',
  },
  {
    id: 'commitments',
    label: 'Commitments',
    icon: CheckSquare,
    path: '/analytics/commitments',
  },
  // Decisions the meeting pipeline recorded.
  {
    id: 'approvals',
    label: 'Approvals',
    icon: Gavel,
    path: '/analytics/approvals',
  },
  {
    id: 'dependencies',
    label: 'Dependencies',
    icon: GitBranch,
    path: '/analytics/dependencies',
  },
  {
    id: 'risks',
    label: 'Risks',
    icon: ShieldAlert,
    path: '/analytics/risks',
  },
  {
    id: 'sla',
    label: 'SLA',
    icon: Clock,
    path: '/analytics/sla',
  },
  // Mail triage: threads ranked for the viewer's delivery role.
  ...(ENABLE_MAIL_INTEL
    ? [
        {
          id: 'mail',
          label: 'Mail',
          icon: Mail,
          path: '/analytics/mail',
          // Shown only to a role that may read mail triage.
          permission: 'mail_intel:inbox:view',
        },
      ]
    : []),
];
